import React from "react";
import TeamCarousel from "../TeamCarousel";

const Team = () => {
  return (
    <div className="App">
      <TeamCarousel />
    </div>
  );
};

export default Team;
